import React, { useCallback, useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { ChevronDown } from '@lyearn/icons';
import { ActionMenu, ActionMenuItemType } from '@lyearn/molecules';
import { Stack, Typography } from '@lyearn/ui';

import { FilterOperators } from '../types';

export interface OperatorsProps {
  operators: FilterOperators[];
  selectedOperator?: FilterOperators;
  setFilterOperator: (val?: FilterOperators) => void;
  className?: string;
}

function Operators(props: OperatorsProps) {
  const { t } = useTranslation();
  const {
    selectedOperator,
    operators,
    setFilterOperator,
    className = 'px-8 py-12 border-b border-solid border-interactive-white-hover',
  } = props;

  const label = useMemo(() => {
    if (!selectedOperator) {
      return t('Common:Filter.SelectOperator');
    }
    return operators.find((operator) => operator.value === selectedOperator.value)?.label;
  }, [operators, selectedOperator, t]);

  const onAction = useCallback(
    (_: string, item: ActionMenuItemType) => {
      setFilterOperator(item as FilterOperators);
    },
    [setFilterOperator],
  );

  return (
    <Stack className={className}>
      <ActionMenu useAnchorElWidth items={operators} onAction={onAction}>
        <Stack
          alignItems="center"
          className="h-40 w-full cursor-pointer rounded-8 border border-solid border-interactive-white-hover px-16 hover:border-border-dark"
          justifyContent="between">
          <Typography variant="body-short-02">{label}</Typography>
          <ChevronDown className="h-20 w-20" fillColorToken="icon-secondary" />
        </Stack>
      </ActionMenu>
    </Stack>
  );
}

export default Operators;
